import React, { useState, useEffect } from 'react';

const API = 'https://khepri.tech/api/v1';

function Analytics() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(API + '/analytics')
      .then(r => r.json())
      .then(setData);
  }, []);

  const exportCSV = () => {
    if (!data) return;
    const rows = [
      ['Метрика', 'Значение'],
      ['CAC', data.metrics.cac],
      ['LTV', data.metrics.ltv],
      ['LTV/CAC', data.metrics.ltv_cac_ratio],
      ['MRR', data.metrics.mrr],
      ['ARR Forecast', data.metrics.arr_forecast],
      ['Churn Rate', data.metrics.churn_rate],
      [],
      ['Стадия воронки', 'Количество'],
      ...data.funnel.map(f => [f.stage, f.count]),
    ];
    const csv = rows.map(r => r.join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Khepri_Аналитика.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const exportPDF = () => {
    window.print();
  };

  if (!data) return <p style={{color:'#94A3B8'}}>Загрузка...</p>;

  const m = data.metrics;
  const funnel = data.funnel;
  const maxCount = Math.max(...funnel.map(f => f.count), 1);

  const monthlyRevenue = m.mrr || 0;
  const annualRevenue = monthlyRevenue * 12;
  const valuationLow = Math.round(annualRevenue * 3);
  const valuationMid = Math.round(annualRevenue * 5);
  const valuationHigh = Math.round(annualRevenue * 7);

  const funnelColors = ['#F7DE8A', '#E6C86E', '#D4B85E', '#C2A84E'];

  const getConversionRate = (index) => {
    if (index === 0) return 100;
    const previous = funnel[index - 1]?.count || 0;
    const current = funnel[index]?.count || 0;
    return previous > 0 ? (current / previous * 100).toFixed(1) : 0;
  };

  const getBarWidth = (index) => {
    const rate = getConversionRate(index);
    return Math.max(rate, 2);
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 10 }}>
        <h2>Панель аналитики</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={exportCSV} style={{ padding: '8px 16px', background: '#F7DE8A', color: '#0F172A', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>
            📥 Экспорт CSV
          </button>
          <button onClick={exportPDF} style={{ padding: '8px 16px', background: '#8A6636', color: '#F8FAFC', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>
            🖨️ Печать / PDF
          </button>
        </div>
      </div>

      {/* Оценка бизнеса */}
      <div style={{ marginBottom: 20, padding: 16, background: '#1E293B', borderRadius: 12, border: '1px solid #8A6636' }}>
        <h3 style={{ marginBottom: 4, color: '#F7DE8A' }}>💼 Оценка бизнеса (DCF)</h3>
        <p style={{ color: '#94A3B8', fontSize: 12, marginBottom: 12 }}>
          Оценочная рыночная стоимость на основе годовой выручки × мультипликатор
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10 }}>
          <div style={{ textAlign: 'center', padding: 10, background: '#0F172A', borderRadius: 8, border: '1px solid #8A6636' }}>
            <div style={{ fontSize: 11, color: '#94A3B8', marginBottom: 4 }}>Консервативно (×3)</div>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#F59E0B' }}>{valuationLow.toLocaleString()} ₽</div>
          </div>
          <div style={{ textAlign: 'center', padding: 10, background: '#0F172A', borderRadius: 8, border: '1px solid #8A6636' }}>
            <div style={{ fontSize: 11, color: '#94A3B8', marginBottom: 4 }}>Базово (×5)</div>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#F7DE8A' }}>{valuationMid.toLocaleString()} ₽</div>
          </div>
          <div style={{ textAlign: 'center', padding: 10, background: '#0F172A', borderRadius: 8, border: '1px solid #8A6636' }}>
            <div style={{ fontSize: 11, color: '#94A3B8', marginBottom: 4 }}>Оптимистично (×7)</div>
            <div style={{ fontSize: 18, fontWeight: 700, color: '#906335' }}>{valuationHigh.toLocaleString()} ₽</div>
          </div>
        </div>
        <p style={{ color: '#94A3B8', fontSize: 11, marginTop: 10 }}>
          На основе годовой выручки: {(annualRevenue || 0).toLocaleString()} ₽. Мультипликаторы: консервативно ×3, базово ×5, оптимистично ×7.
        </p>
      </div>

      {/* Ключевые метрики */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10, marginBottom: 20 }}>
        <div style={{...cardStyle, border: '1px solid #8A6636'}}><div style={labelStyle}>CAC</div><div style={{...valueStyle, color: '#F7DE8A'}}>{m.cac.toLocaleString()} ₽</div></div>
        <div style={{...cardStyle, border: '1px solid #8A6636'}}><div style={labelStyle}>LTV</div><div style={{...valueStyle, color: '#F7DE8A'}}>{m.ltv.toLocaleString()} ₽</div></div>
        <div style={{...cardStyle, border: '1px solid #8A6636'}}><div style={labelStyle}>LTV/CAC</div><div style={{...valueStyle, color: '#F7DE8A'}}>{m.ltv_cac_ratio}</div></div>
        <div style={{...cardStyle, border: '1px solid #8A6636'}}><div style={labelStyle}>MRR</div><div style={{...valueStyle, color: '#F7DE8A'}}>{m.mrr.toLocaleString()} ₽</div></div>
        <div style={{...cardStyle, border: '1px solid #8A6636'}}><div style={labelStyle}>Прогноз ARR</div><div style={{...valueStyle, color: '#F7DE8A'}}>{m.arr_forecast.toLocaleString()} ₽</div></div>
        <div style={{...cardStyle, border: '1px solid #8A6636'}}><div style={labelStyle}>Отток</div><div style={{...valueStyle, color: '#F7DE8A'}}>{m.churn_rate}</div></div>
      </div>

      {/* Воронка */}
      <h3 style={{ marginBottom: 12, color: '#F7DE8A' }}>Воронка конверсии</h3>
      <div style={{ padding: 16, background: '#1E293B', borderRadius: 12, border: '1px solid #8A6636', marginBottom: 20 }}>
        {funnel.map((f, i) => {
          const conversion = getConversionRate(i);
          const barWidth = getBarWidth(i);
          return (
            <div key={i} style={{ marginBottom: 16 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 13, marginBottom: 4 }}>
                <span style={{ color: '#F8FAFC' }}>{f.stage}</span>
                <span style={{ color: '#94A3B8' }}>{f.count} {i > 0 && `(конверсия ${conversion}%)`}</span>
              </div>
              <div style={{ background: '#0F172A', borderRadius: 8, height: 36, overflow: 'hidden', border: '1px solid #334155' }}>
                <div
                  style={{
                    width: `${barWidth}%`,
                    height: '100%',
                    background: funnelColors[i % funnelColors.length],
                    borderRadius: 8,
                    transition: 'width 0.5s ease',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    paddingRight: 8,
                  }}
                >
                  <span style={{ fontSize: 12, fontWeight: 700, color: '#0F172A' }}>{barWidth.toFixed(0)}%</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const cardStyle = { background: '#1E293B', padding: 14, borderRadius: 8, textAlign: 'center' };
const labelStyle = { fontSize: 10, color: '#94A3B8', textTransform: 'uppercase', marginBottom: 4 };
const valueStyle = { fontSize: 16, fontWeight: 700 };

export default Analytics;